module.exports = __webpack_public_path__ + "img/sx.32163d8b.svg";